import { Link } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import style from './style.module.scss';
import { Link as ReactLink } from 'react-router-dom';

interface BigTextLinkProps {
    onClick?: () => void;
    color?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
    route?: string;
}

export const BigTextLink = React.memo((props: PropsWithChildren<BigTextLinkProps>) => {
    return (
        <Link
            {...( props.route ? { component: ReactLink, to: props.route } : undefined) }
            className={style.link}
            component={ReactLink}
            to={props?.route ?? ''}
            style={{ textDecoration: 'none', color: props.color, ...props.style }}
            onClick={props.disabled ? undefined : props.onClick}
            underline='hover'
        >
            {props.children}
        </Link>
    );
});
